<template>
  <lb-dialog
    v-model="dialogVisible"
    :heading="heading"
    width="60vw"
    persistent
    :data-testid="`prompt-dialog__${mode}-dialog`"
  >
    <template v-slot:body>
      <v-row class="mt-4" data-testid="prompt-dialog__body">
        <template v-if="isAddMode">
          <v-col cols="6" class="my-0 py-1">
            <lb-dropdown
              label="Type*"
              v-model="localPrompt.type"
              :items="featureItems"
              :error="errors.type"
              data-testid="prompt-dialog__type-dropdown"
            />
          </v-col>
          <v-col cols="6" class="my-0 py-1">
            <lb-string
              label="Feature"
              v-model="localPrompt.feature"
              disabled
              data-testid="prompt-dialog__feature-input"
            />
          </v-col>
          <v-col cols="6" class="my-0 py-1">
             <lb-string
              label="Name"
              v-model="localPrompt.name"
              data-testid="prompt-dialog__name-input"
            />
          </v-col>
          <v-col cols="6" class="my-0 py-1">
            <v-switch
              v-model="localPrompt.status"
              inset
              color="success"
              class="ma-0"
              :false-value="false"
              :true-value="true"
              hide-details
              label="Status"
              data-testid="prompt-dialog__status-switch"
            />
          </v-col>
          <v-col cols="12" class="my-0 py-1">
            <lb-textarea
               label="Content*"
               v-model="localPrompt.content"
               :error="errors.content"
               rows="5"
               data-testid="prompt-dialog__content-textarea"
            />
          </v-col>
        </template>
        <template v-else>
          <v-col cols="6" class="my-0 py-1">
            <lb-string label="Type" v-model="localPrompt.type" disabled data-testid="prompt-dialog__type-input-disabled" />
          </v-col>
          <v-col cols="6" class="my-0 py-1">
            <lb-string label="Name" v-model="localPrompt.name" disabled data-testid="prompt-dialog__name-input-disabled" />
          </v-col>
          <v-col cols="12" class="my-0 py-1">
             <lb-textarea label="Content" v-model="localPrompt.content" rows="10" data-testid="prompt-dialog__content-textarea-edit" />
          </v-col>
          <v-col cols="12" class="my-0 py-1">
            <v-switch
              v-model="localPrompt.status"
              inset
              color="success"
              class="ma-0"
              :false-value="false"
              :true-value="true"
              hide-details
              label="Status"
              data-testid="prompt-dialog__status-switch-edit"
            />
          </v-col>
        </template>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save" :loading="loading" data-testid="prompt-dialog__save-btn">{{ actionLabel }}</v-btn>
    </template>
  </lb-dialog>
</template>

<script>
import { PROMPT_MODES, PROMPT_DIALOG, PROMPT_FEATURE_ITEMS } from '@/modules/admin/utils/constants';
export default {
  name: 'PromptDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: PROMPT_MODES.ADD // 'add' or 'edit'
    },
    promptData: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      featureItems: PROMPT_FEATURE_ITEMS,
      localPrompt: {}
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    isAddMode() {
      return this.mode === PROMPT_MODES.ADD;
    },
    heading() {
      return this.mode === PROMPT_MODES.ADD ? PROMPT_DIALOG.HEADINGS.ADD : PROMPT_DIALOG.HEADINGS.EDIT;
    },
    actionLabel() {
      return this.mode === PROMPT_MODES.ADD ? PROMPT_DIALOG.ACTION_LABELS.ADD : PROMPT_DIALOG.ACTION_LABELS.EDIT;
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.localPrompt = { ...this.promptData };
      }
    }
  },
  methods: {
    save() {
      this.$emit('save', this.localPrompt);
    }
  }
};
</script>